/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-04-26 10:45:42
 */
// import {defaultRouter, addRouter} from '@/router/index'

// const routerData = {
//   state: {
//     routers: [],
//     addRouters: []
//   },
//   mutations: {
//     setRouters: (state, routers) => {
//       state.addRouters = routers  // 保存动态路由用来addRouter
//       state.routers = defaultRouter.concat(routers) // 所有有权限的路由表，用来生成菜单列表
//     }
//   },
//   actions: {
//     newRoutes ({commit}, role) {
//       //  通过递归路由表，删除掉没有权限的路由
//       function eachSelect (routers, userRole) {
//         for (let j = 0; j < routers.length; j++) {
//           if (routers[j].meta && routers[j].meta.role.length && routers[j].meta.role.indexOf(userRole) === -1) {
//             routers.splice(j, 1)
//             j = j !== 0 ? j - 1 : j
//           }
//           if (routers[j].children && routers[j].children.length) {
//             eachSelect(routers[j].children, userRole)
//           }
//         }
//       }
//       // 拷贝这个数组是因为做权限测试的时候可以从低级切回到高级角色，仅限演示，正式开发时省略这步直接使用 addRouter
//       let newArr = [...addRouter]
//       eachSelect(newArr, role)
//       commit('setRouters', newArr)

//       // 正式开发
//       // eachSelect(addRouter, role)
//       // commit('setRouters', addRouter)
//     }
//   }
// }

// export default routerData

import { defaultRouter, addRouter } from "@/router/index";
import store from "../index";

const routerData = {
  state: {
    routers: [],
    addRouters: []
  },
  mutations: {
    setRouters: (state, routers) => {
      state.addRouters = routers; // 保存动态路由用来addRouter
      state.routers = defaultRouter.concat(routers); // 所有有权限的路由表，用来生成菜单列表
      localStorage.setItem("routers", state.routers);
    }
  },
  actions: {
    newRoutes({ commit }, perRouter) {
      //  通过递归路由表，删除掉没有权限的路由
      function eachSelect(routers, userRole) {
        for (let j = 0; j < routers.length; j++) {
          if (
            routers[j].key &&
            userRole.indexOf(routers[j].key.toString()) === -1
          ) {
            routers.splice(j, 1);
            j = j - 1;
          }
          if (routers[j] && routers[j].children && routers[j].children.length) {
            eachSelect(routers[j].children, userRole);
            if (!routers[j].children.length) {
              routers.splice(j, 1);
              j = j - 1;
            }
          }
        }
      }
      if (store.getters.info.role !== "超级管理员") {
        eachSelect(addRouter, perRouter);
      }
      commit("setRouters", addRouter);
    },
    initRoutes({ commit }, data) {
      return new Promise(resolve => {
        //  通过递归路由表，删除掉没有权限的路由
        function eachSelect(routers, userRole) {
          for (let j = 0; j < routers.length; j++) {
            if (
              routers[j].key &&
              userRole.indexOf(routers[j].key.toString()) === -1
            ) {
              routers.splice(j, 1);
              j = j - 1;
            }
            if (
              routers[j] &&
              routers[j].children &&
              routers[j].children.length
            ) {
              eachSelect(routers[j].children, userRole);
              if (!routers[j].children.length) {
                routers.splice(j, 1);
                j = j - 1;
              }
            }
          }
        }
        if (store.getters.info.role !== "超级管理员") {
          eachSelect(addRouter, data);
        }
        commit("setRouters", addRouter);
        resolve();
      });
    }
  }
};

export default routerData;



// WEBPACK FOOTER //
// ./src/vuex/modules/routerData.js